import { render, staticRenderFns } from "./HomeMultilista.vue?vue&type=template&id=45dfa4e0&scoped=true"
import script from "./HomeMultilista.vue?vue&type=script&lang=js"
export * from "./HomeMultilista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dfa4e0",
  null
  
)

export default component.exports